var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "time-traveller hidden-print" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-unstyled",
        attrs: { id: "time-traveller-previous", disabled: _vm.prevExceeded },
        on: {
          click: function($event) {
            return _vm.getPrevious()
          }
        }
      },
      [
        _c("font-awesome-icon", { attrs: { icon: "arrow-circle-left" } }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.commonContent.previous")))
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex align-items-center" }, [
      _c("strong", [
        _vm._v(
          " " +
            _vm._s(_vm.$t("MAIN_CONTENT.TimeTraveller.weekOfWithColon")) +
            " "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { display: "inline-block" } },
        [
          _c("date-picker", {
            ref: "selectedDatePickerInput",
            attrs: {
              name: "selectedDate",
              "aria-label":
                _vm.$t("MAIN_CONTENT.TimeTraveller.weekOfWithColon") +
                " " +
                _vm.$t(_vm.getDisplayText),
              describedByID: "weekOfDateInput",
              datePickerInputMessage: _vm.$t(
                "MAIN_CONTENT.TimeTraveller.datepickerAriaMessage"
              ),
              label:
                _vm.$t("MAIN_CONTENT.TimeTraveller.weekOfWithColon") +
                " " +
                _vm.$t(_vm.getDisplayText),
              disabled: false,
              notBefore: _vm.getBeforeRange(),
              notAfter: _vm.getAfterRange(),
              locale:
                _vm.getSelectedLocale.LOCALE_CODE !== "sa-us"
                  ? _vm.getSelectedLocale.LOCALE_CODE
                  : "en-US",
              format: "MM/DD/YYYY",
              lang: "en",
              showLabel: false,
              clearable: false
            },
            model: {
              value: _vm.displayDate,
              callback: function($$v) {
                _vm.displayDate = $$v
              },
              expression: "displayDate"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-unstyled",
        attrs: { disabled: _vm.nextExceeded },
        on: {
          click: function($event) {
            return _vm.getNext()
          }
        }
      },
      [
        _c("span", [_vm._v(_vm._s(_vm.$t("MAIN_CONTENT.commonContent.next")))]),
        _vm._v(" "),
        _c("font-awesome-icon", { attrs: { icon: "arrow-circle-right" } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }